import {
  createStyles,
  makeStyles,
  Tab,
  Tabs,
  useMediaQuery,
} from "@material-ui/core";
import React from "react";

import { CustomTheme } from "../../../../types/customTheme";
import DashboardChart from "./DashboardChart";

const useStyles = makeStyles<any>((theme: CustomTheme) =>
  createStyles({
    tabPanel: {
      backgroundColor: theme.palette.background.entity_background,
    },
    tabStyle: {
      minWidth: "0px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px",
      },
    },
  }),
);

export interface ChartTypeProps {
  previousStartDate: any;
  previousEndDate: any;
  currentStartDate: any;
  currentEndDate: any;
  shortCurrentDateRange: any;
  previousDashboardNodeList: any;
  currentDashboardNodeList: any;
  paymentNodeList: any;
  previousPaymentNodeList: any;
  ordersNodeList: any;
  previousOrdersNodeList: any;
  averageNodeList: any;
  previousAverageNodeList: any;
  platformNodeList: any;
  previousPlatformNodeList: any;
  modeNodeList: any;
  previousModeNodeList: any;
  channelNodeList: any;
  previousChannelNodeList: any;
  isEmpty?: any;
  currentSalesTotal: any;
  previousSalesTotal: any;
  salesTotalNode: any;
}

interface TabPanelProps {
  children: React.ReactNode;
  index: any;
  value: any;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      className={classes.tabPanel}
      hidden={value !== index}
      id={`sale-dashboard-chart-type-tab-${index}`}
      aria-labelledby={`sale-dashboard-chart-type-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
};

/*
 * ChartType is a React functional component responsible for rendering a tabbed interface
 * for displaying different types of charts based on the provided data.
 * It utilizes Material-UI's Tabs and Tab components to switch between different chart types.
 * The component receives various props including data related to sales, orders, average, payments,
 * platform, mode, channel, and date ranges.
 * Each tab corresponds to a specific type of chart (e.g., sales, orders, average, etc.) and renders
 * a DashboardChart component with appropriate data and configurations.
 * The component also handles tab switching and adjusts its appearance based on screen size using
 * Material-UI's useMediaQuery hook.
 */
const ChartType: React.FunctionComponent<ChartTypeProps> = ({
  previousStartDate,
  previousEndDate,
  currentStartDate,
  currentEndDate,
  shortCurrentDateRange,
  previousDashboardNodeList,
  currentDashboardNodeList,
  paymentNodeList,
  previousPaymentNodeList,
  ordersNodeList,
  previousOrdersNodeList,
  averageNodeList,
  previousAverageNodeList,
  platformNodeList,
  previousPlatformNodeList,
  modeNodeList,
  previousModeNodeList,
  channelNodeList,
  previousChannelNodeList,
  isEmpty,
  currentSalesTotal,
  previousSalesTotal,
  salesTotalNode,
}) => {
  const [value, setValue] = React.useState<number>(0);

  /* Switch the tab to be displayed. */
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  const [checked, setChecked] = React.useState(true);
  const [checkedCurrentPreviousToggle, setCheckedCurrentPreviousToggle] =
    React.useState(true);
  const [valueToggle, setValueToggle] = React.useState("line");
  const maxWidth = useMediaQuery("(max-width: 600px)");
  const classes = useStyles();
  return (
    <>
      <DashboardChart
        currentStartDate={currentStartDate}
        currentEndDate={currentEndDate}
        shortCurrentDateRange={shortCurrentDateRange}
        previousDashboardNodeList={previousPaymentNodeList}
        dashboardNodeList={paymentNodeList}
        order={false}
        checkedCurrentPreviousToggle={checkedCurrentPreviousToggle}
        value={valueToggle}
        setValue={setValueToggle}
        isEmpty={isEmpty}
        salesTotalNode={salesTotalNode}
      />
    </>
  );
};

export default ChartType;
